import React from 'react';
import TopBar from '../TopBar';
import Footer from '../Footer';
import { BetaThemeProvider, useBetaTheme } from '../../context/BetaThemeContext';
import '../../styles/beta/BetaLayout.scss';

interface BetaLayoutProps {
  children: React.ReactNode;
  isAdmin?: boolean;
  brandAirlines?: string[];
}

const BetaLayoutInner: React.FC<BetaLayoutProps> = ({ children, isAdmin = false, brandAirlines = [] }) => {
  const { theme, toggleTheme } = useBetaTheme();
  return (
    <div className="layout beta-themed-layout" data-theme={theme}>
      <TopBar
        isAdmin={isAdmin}
        brandAirlines={brandAirlines}
        isBeta={true}
        theme={theme}
        onToggleTheme={toggleTheme}
      />
      <main className="layout-body beta-layout-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

const BetaLayout: React.FC<BetaLayoutProps> = (props) => (
  <BetaThemeProvider>
    <BetaLayoutInner {...props} />
  </BetaThemeProvider>
);

export default BetaLayout;
